// extracted by mini-css-extract-plugin
module.exports = {"tile-item":"tile-item__33mov"};